import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    topic: {},
    topicComponents: [],
    presentation: {Page: 0, Record: null, IsTopic: true}
}

export const topicSlice = createSlice({
    name: "topic",
    initialState,
    reducers: {
        setTopic: (state, action) => {
            state.topic = action.payload;
        },
        setTopicComponents: (state, action) => {
            state.topicComponents = action.payload;
        },
        setPresentation: (state, action) => {
            state.presentation = action.payload;
        }
    }
});

//SETTER: set values to variables
export const {
    setTopic,
    setTopicComponents,
    setPresentation
} = topicSlice.actions;

export const topicData = (state)=>state.topic;
export default topicSlice.reducer;